// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Za1c","large":"styles_large__TadmJ"};